import React from 'react';
import {I18n} from 'react-redux-i18n';

import {withStyles, WithStyles} from '@material-ui/core/styles';
import {CustomButton} from '../../material-dashboard-pro-react/components/index';
import {Erase} from '../../icons/index';
import style from './style';

type ButtonResetEntityProps = WithStyles<typeof style> & {
  customClasses?: string;
  disabled?: boolean;
  entityType?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  text?: string | null;
}

function ButtonResetEntity({
  classes,
  customClasses = '',
  disabled = false,
  entityType = '',
  onClick,
  text = null,
}: ButtonResetEntityProps) {
  const defaultText = typeof I18n?.t === 'function'
    ? String(I18n.t('buttons.resetEntity', {entityType}))
    : `Reset ${entityType}`;
  const buttonText = text || defaultText;

  return (
    <CustomButton
      color="red"
      customClasses={customClasses}
      disabled={disabled}
      onClick={onClick}
      size="xs"
    >
      <div className={classes.button__icon}>
        <Erase className={classes.icon__svg} />
      </div>
      {buttonText.toUpperCase()}
    </CustomButton>
  );
}

export default withStyles(style)(ButtonResetEntity);
